import { buildStonTonToSpottyStep, buildStonUsdtToTonStep } from './step-builders'
import type { RouteContext, RouteStep, RouteStrategy } from './types'

/**
 * Symbiosis route: EVM token → USDT on TON → TON → SPOTTY.
 * Three steps: Symbiosis bridge, STON.fi USDT→TON, STON.fi TON→SPOTTY.
 */
class SymbiosisStrategy implements RouteStrategy {
  compute(ctx: RouteContext): RouteStep[] {
    const usdtUsdSuffix = ctx.bridgeOutputUsd ? ` (${ctx.bridgeOutputUsd})` : ''
    const bridgeAmountOut = ctx.bridgeOutputAmount ? `~${ctx.bridgeOutputAmount}` : '...'

    const stonCtx = {
      previewLoading: ctx.previewLoading,
      tonAmount: ctx.tonAmount,
      spottyAmount: ctx.spottyAmount,
      bridgeOutputAmount: ctx.bridgeOutputAmount,
    }

    return [
      {
        key: 'bridge',
        label: 'Bridge via Symbiosis',
        amountLine: `${ctx.sourceAmount} ${ctx.fromToken} → ${bridgeAmountOut} USDT${usdtUsdSuffix}`,
        amountLoading: false,
        status: ctx.step1Status,
        txLinks: ctx.bridgeTxLinks,
        etaHint: ctx.bridgeEtaHint,
      },
      buildStonUsdtToTonStep(stonCtx, ctx.step2Status, ctx.tonUsdtToTonTxUrl),
      buildStonTonToSpottyStep(stonCtx, ctx.step3Status, ctx.tonTxUrl),
    ]
  }
}

export const symbiosisStrategy = new SymbiosisStrategy()
